/**
 * @generated SignedSource<<f1f47f20b1b36ec2ee4d84c26b23dd43>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalContacts",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserExternalContactsUpdateModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserExternalContactsUpdateModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "92a1f2c25e2b94b7b9a0aede3b8d3fbc",
            "id": null,
            "metadata": {},
            "name": "UserExternalContactsUpdateModalQuery",
            "operationKind": "query",
            "text": "query UserExternalContactsUpdateModalQuery(\n  $userId: ID!\n) {\n  user(id: $userId) {\n    externalContacts\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "8d5c5e7e1fb687d8d005064ba38f5389";
export default node;
